import { TagCommanderEvent, TagCommanderVars, WindowWithTagCommander } from './tag-commander.types';

export const TAG_COMMANDER_VARS_MASK = {
  site_environnement: '',
  site_parcours: '',
  url_log: '',
  url_slog: '',
  page_s1: '',
  page_s2: '',
  page_xtpage: '',
  page_chapitre: '',
  page_sous_chapitre: '',
  page_sous_sous_chapitre: '',
  page_page: '',
  page_template: '',
  user_id: '',
  user_id_AT: '',
  src: '',
  type: '',
  cat: '',
  num_dossier: '',
  offre_souscrite: '',
  maturite_projet: '',
  appetence_immo: '',
  type_page: '',
};

export function callTagCommanderTrackEvent(win: WindowWithTagCommander, event: TagCommanderEvent): void {
  if (!win) {
    return;
  }

  if (!win.tc_events_26) {
    console.warn(`Failed to track event "${event.type}": tc_events_26 function is undefined`);
    return;
  }

  try {
    win.tc_events_26(win, event.type, event.options);
  } catch (err) {
    console.warn(err);
  }
}

export function getTagCommanderVarsScriptCode(vars: TagCommanderVars): string {
  return (
    'tc_vars = {};\n' +
    Object.keys(vars)
      .map(key => `tc_vars["${key}"] = ${JSON.stringify(vars[key])};`)
      .join('\n')
  );
}

export function getVarsForTrackPageView(
  page: string,
  chapter?: string,
  subChapter?: string,
  subSubChapter?: string,
): Partial<TagCommanderVars> {
  const vars: Partial<TagCommanderVars> = {
    page_page: '',
    page_chapitre: '',
    page_sous_chapitre: '',
    page_sous_sous_chapitre: '',
  };
  const labelParts: string[] = [];

  if (page && chapter) {
    vars.page_chapitre = chapter;
    labelParts.push(chapter);
  }

  if (page && chapter && subChapter) {
    vars.page_sous_chapitre = subChapter;
    labelParts.push(subChapter);
  }

  if (page && chapter && subChapter && subSubChapter) {
    vars.page_sous_sous_chapitre = subSubChapter;
    labelParts.push(subSubChapter);
  }

  if (page) {
    vars.page_page = page;
    labelParts.push(page);
  }

  vars.page_xtpage = labelParts.join('::');

  return vars;
}
